/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : DashboardIcon.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";

export function PieSliceIcon({ selected = false }) {
  return (
    <SvgIcon viewBox="0 0 29 29">
      <circle
        cx="13"
        cy="13"
        r="12"
        fill={selected ? "black" : "white"}
        stroke="currentColor"
        strokeWidth="2"
      />

      <line
        x1="12"
        y1="12"
        x2="10"
        y2="1"
        stroke={selected ? "white" : "black"}
        strokeWidth="2"
      />
      <line
        x1="12"
        y1="12"
        x2="24"
        y2="5"
        stroke={selected ? "white" : "black"}
        strokeWidth="2"
      />
      <line
        x1="12"
        y1="12"
        x2="24"
        y2="20"
        stroke={selected ? "white" : "black"}
        strokeWidth="2"
      />
    </SvgIcon>
  );
}

PieSliceIcon.propTypes = {
  selected: PropTypes.bool,
};
